import React, { useState, useRef, useEffect } from 'react'

import {
  StepsTitle, Duration, Timer, StepsContainer, FullStep, FlexH, FlexV,
  StepNumber, StepText, ButtonsDiv, BackNextButton, CompletedText
} from './EventStyledComponents'
import { AddToEventButton as MarkAsCompletedButton } from '../Activity/ActivityStyledComponents'
import { ArrowLeft, ArrowRight } from '../Icons'

const Stepper = props => {
  const {
    isEventFinished, setEventFinished, setOverview, seconds,
    setCurrentStep, currentStep, currentActivity, setCurrentActivity, currentPhase,
    setCurrentPhase, phasesLength, setTimerActive, hasInstructions, setHasInstructions
  } = props

  const { event, setEvent } = props
  const activeStepRef = useRef(null)
  const instructionRef = useRef(null)
  const phase = event.phases[currentPhase]
  const activity = phase?.data[currentActivity]
  const activitiesLength = phase?.data?.length - 1
  const [areAllStepsPassed, setAllStepsPassed] = useState(false)
  const stepsLength = activity?.steps.length - 1
  const durationMin = activity?.duration_min || '?'
  const durationMax = activity?.duration_max || '?'

  const nextButtonText = () => {
    let text = 'next activity'
    if (currentPhase === phasesLength && currentActivity === activitiesLength) {
      text = 'finish'
    }
    return text
  }
  useEffect(() => {
    if (activity.instructions) { setHasInstructions(true) }
  }, [])

  const onStepChange = step => {
    step < 0
      ? setOverview(true)
      : step > stepsLength
        ? setCurrentStep(stepsLength)
        : setCurrentStep(step)
  }

  const onActivityChange = activity => {
    if (activity > activitiesLength) {
      onPhaseChange(currentPhase + 1)
    } else {
      setCurrentStep(0)
      setCurrentActivity(activity)
      setOverview(true)
      setEventFinished(false)
    }
  }
  const onPhaseChange = phase => {
    if (phase < 0) {
      setCurrentStep(0)
      setCurrentActivity(0)
      setCurrentPhase(0)
      setOverview(true)
      setTimerActive(true)
    } else if (phase > phasesLength) {
      setCurrentStep(stepsLength)
      setCurrentActivity(activitiesLength)
      setCurrentPhase(phasesLength)
      setOverview(true)
      setEventFinished(true)
    } else {
      setCurrentStep(0)
      setCurrentActivity(0)
      setCurrentPhase(phase)
      setOverview(true)
    }
  }
  const onNextStep = () => {
    if (hasInstructions) {
      instructionRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
      setCurrentStep(0)
    } else {
      onStepChange(currentStep + 1)
      activeStepRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
    setHasInstructions(false)
  }
  const onPreviousStep = () => {
    if (areAllStepsPassed) {
      setAllStepsPassed(false)
      setTimerActive(true)
    } else {
      onStepChange(currentStep - 1)
      activeStepRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }
  }
  const onCompleted = () => {
    activity.isCompleted = true
    const isPhaseDone = phase.data.every(activity => activity.isCompleted)
    if (isPhaseDone) {
      phase.isCompleted = true
    }
    setTimerActive(false)
    setEvent({ ...event })
    setAllStepsPassed(true)
  }
  const onNextActivity = () => {
    onActivityChange(currentActivity + 1)
    setTimerActive(true)
  }

  const instructionsClickHandler = () => {
    instructionRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  const onStepClickHandler = newStep => {
    if (newStep > currentStep) {
      activeStepRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
    } else if (newStep < currentStep) {
      activeStepRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }
    onStepChange(newStep)
  }
  return (
    <>
      {!isEventFinished &&
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {!activity?.instructions ? null
              : <StepsTitle>INSTRUCTIONS</StepsTitle>}
            <StepsTitle>STEPS</StepsTitle>
            <div style={{ display: 'flex' }}>
              <Duration>{durationMin} - {durationMax} min </Duration>
              <Timer>
                {parseInt(seconds / 60) < 10 ? '0' + parseInt(seconds / 60) : parseInt(seconds / 60)}
                &#8203;
                : {seconds % 60 < 10 ? '0' + seconds % 60 : seconds % 60}
              </Timer>
            </div>
          </div>
          <StepsContainer>
            <FlexH>
              <FlexV>
                {!activity.instructions ? null
                  : <div ref={instructionRef} style={{ width: '270px' }}>{activity.instructions}</div>}
              </FlexV>
              <FlexV>
                {activity?.steps.map((step, index) => {
                  return (
                    <FullStep
                      key={index}
                      highlight={currentStep === index && !areAllStepsPassed}
                      ref={currentStep === index ? activeStepRef : null}
                      onClick={
                        !areAllStepsPassed && hasInstructions
                          ? () => instructionsClickHandler()
                          : !hasInstructions
                            ? () => onStepClickHandler(index)
                            : () => {}
                      }
                    >
                      <StepNumber>{index < 9 ? '0' + (index + 1) : index + 1}</StepNumber>
                      {step?.description1?.map((item, index) => (
                        <StepText key={index}>{item.text} <br /></StepText>
                      ))}
                    </FullStep>
                  )
                })}
              </FlexV>
            </FlexH>
          </StepsContainer>
          <div style={areAllStepsPassed ? { display: 'flex', justifyContent: 'space-between' } : { display: 'flex', justifyContent: 'flex-end' }}>
            {areAllStepsPassed && <CompletedText>&#10003; COMPLETED</CompletedText>}
            <ButtonsDiv>
              <BackNextButton onClick={onPreviousStep}> <ArrowLeft />&nbsp; back </BackNextButton>
              {currentStep === stepsLength
                ? areAllStepsPassed
                  ? <BackNextButton onClick={onNextActivity}> {nextButtonText()} &nbsp; <ArrowRight /> </BackNextButton>
                  : <MarkAsCompletedButton onClick={onCompleted}>Mark as completed </MarkAsCompletedButton>
                : <BackNextButton onClick={onNextStep}> next &nbsp; <ArrowRight /> </BackNextButton>}
            </ButtonsDiv>
          </div>
        </>}
    </>
  )
}

export default Stepper
